const productGallery = document.querySelector(".product-gallery__image-list");
const productVideos = productGallery?.querySelectorAll("video");

if (productGallery && productVideos.length > 0) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;

        if (entry.intersectionRatio > 0) {
          if (video.paused) {
            video.play().catch((e) => {
              console.warn("Erreur de lecture auto:", e);
            });
          }
        } else {
          if (!video.paused) {
            video.pause();
          }
        }
      });
    },
    {
      threshold: 0.1,
    }
  );

  productVideos.forEach((video) => observer.observe(video));
}